export default {
  install(Vue, opts = {}) {
    Vue.prototype.$generateNewPassword = () => {
      const length = 6
      const charset = 'abcdefghjkmnpqrstuvwxyzABCDEFGHIJKMNPQRSTUVWXYZ23456789'
      let retVal = ''
      const n = charset.length
      for (let i = 0; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n))
      }
      return retVal
    }
  },
}
